import { localizedCopy } from 'features/result-content/resultContent';

export function TagChip({ tag, locale, t, onRemove, removable = false }) {
  if (!tag) {
    return null;
  }
  const name = localizedCopy(tag, locale, 'name');
  const archived = Boolean(tag.is_archived);
  const inactive = tag.is_active === false;
  const status = archived
    ? t('resultContent.archivedTag')
    : inactive
      ? t('filters.inactive')
      : null;

  return (
    <span className="tag-chip">
      <span
        className="tag-chip-swatch"
        aria-hidden="true"
        style={{ background: tag.color || 'var(--brand)' }}
      />
      <span>{name}</span>
      {status ? <span className="tag-chip-status">({status})</span> : null}
      {removable && onRemove ? (
        <button
          type="button"
          className="tag-chip-remove"
          onClick={() => onRemove(tag.id)}
          aria-label={`${t('actions.remove')} ${name}`}
        >
          ×
        </button>
      ) : null}
    </span>
  );
}

export function TagChipRow({ tags = [], locale, t }) {
  if (!tags.length) {
    return null;
  }
  return (
    <div className="chip-row">
      {tags.map((tag) => (
        <TagChip key={tag.id || tag.name_en} tag={tag} locale={locale} t={t} />
      ))}
    </div>
  );
}
